const REVIEW_ONBOARDING_STEP = {
  active: false,
  code: 'onboarding__review',
  id: 999,
  isFinished: null,
  status: null,
  substeps: [
    {
      active: false,
      code: 'onboarding__review_review',
      id: 9999,
      isFinished: null,
      status: null,
      title: 'Review',
      view: 'onboarding__review_review'
    }
  ],
  title: 'Review',
  view: 'onboarding__review'
};

export default REVIEW_ONBOARDING_STEP;
